/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Winterinoccpressuresetpoint3Inputs */



/**
* | output |
* | --- |
* | "Winter unoccupied pressure setpoint" |
*
* @param {Ahu_History_Key_Winterinoccpressuresetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_winterinoccpressuresetpoint3 = /** @type {((inputs?: Ahu_History_Key_Winterinoccpressuresetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Winterinoccpressuresetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter unoccupied pressure setpoint")
	return /** @type {LocalizedString} */ ("Consigne de pression inoccupation hiver")
});
export { ahu_history_key_winterinoccpressuresetpoint3 as "ahu_history_key_winterInoccPressureSetpoint" }